import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/bitnami/apache/htdocs/matco-v2-back/src/app/producto-nuevo/[productSlug]/ProductDetailsClient.tsx");
